import { render } from "./EReceipt.vue?vue&type=template&id=c6118176&scoped=true&ts=true"
import script from "./EReceipt.vue?vue&type=script&lang=ts"
export * from "./EReceipt.vue?vue&type=script&lang=ts"

import "./EReceipt.vue?vue&type=style&index=0&id=c6118176&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6118176"]])

export default __exports__